import icon1 from './assets/01.jsx';
import icon2 from './assets/02.jsx';
import icon3 from './assets/03.jsx';
import icon4 from './assets/04.jsx';

export const AdverisersContent = [
  {
    icon: icon1,
    title: 'Quality Leads & Zero Fraud',
    text: 'VMG’s Network of Super Affiliates and marketing methods have been fully vetted to ensure the highest quality leads with zero fraud.',
  },
  {
    icon: icon2,
    title: 'Maximize Your Profits',
    text: 'At VMG, we work with you to optimize, scale, and increase your profits. We analyze data and will develop a marketing strategy that will work for you.',
  },
  {
    icon: icon3,
    title: 'Deep Analytics and Powerful Data',
    text: 'At VMG we automatically gather and collect hundreds of vital data points that will assist in helping you drill down and reach even higher ROIs.',
  },
  {
    icon: icon4,
    title: 'We’re Here To Help. 24/7',
    text: 'We keep an open line of communication with our advertisers to ensure all questions and concerns are answered promptly.',
  },
];
